// Interpret the launch time as a Los Angeles wall-clock time, using the
// daylight-saving offset that applies on the launch date.
(() => {
  const value = document.documentElement.dataset.launchLocal || "";
  const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?$/.exec(
    value,
  );
  if (!match) {
    window.bodyLaunchAt = NaN;
    return;
  }

  const [
    ,
    yearText,
    monthText,
    dayText,
    hourText,
    minuteText,
    secondText = "00",
  ] = match;
  const [year, month, day, hour, minute, second] = [
    yearText,
    monthText,
    dayText,
    hourText,
    minuteText,
    secondText,
  ].map(Number);
  const localAsUTC = Date.UTC(year, month - 1, day, hour, minute, second);
  const inputIsValid =
    year >= 2000 &&
    month >= 1 &&
    month <= 12 &&
    day >= 1 &&
    day <= 31 &&
    hour <= 23 &&
    minute <= 59 &&
    second <= 59 &&
    new Date(localAsUTC).getUTCMonth() === month - 1 &&
    new Date(localAsUTC).getUTCDate() === day;
  if (!inputIsValid) {
    window.bodyLaunchAt = NaN;
    return;
  }

  const formatter = new Intl.DateTimeFormat("en-GB", {
    timeZone: "America/Los_Angeles",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hourCycle: "h23",
  });

  let instant = localAsUTC;
  for (let attempt = 0; attempt < 4; attempt++) {
    const parts = Object.fromEntries(
      formatter
        .formatToParts(instant)
        .map(({ type, value: part }) => [type, Number(part)]),
    );
    const shownAsUTC = Date.UTC(
      parts.year,
      parts.month - 1,
      parts.day,
      parts.hour,
      parts.minute,
      parts.second,
    );
    const correction = localAsUTC - shownAsUTC;
    instant += correction;
    if (correction === 0) break;
  }

  const resolved = Object.fromEntries(
    formatter
      .formatToParts(instant)
      .map(({ type, value: part }) => [type, Number(part)]),
  );
  window.bodyLaunchAt =
    resolved.year === year &&
    resolved.month === month &&
    resolved.day === day &&
    resolved.hour === hour &&
    resolved.minute === minute &&
    resolved.second === second
      ? instant
      : NaN;
})();
